export default "__VITE_ASSET__BQkeJy2N__"